import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Logo } from "../../assets";
import {
  FaBlog,
  FaHome,
  FcAbout,
  MdEventSeat,
  MdForum,
} from "../../assets/icons/index";
import { useStateValue } from "../../context/StateProvider";
import {
  isActiveStyles,
  isIconActiveStyles,
  isNotActiveStyles,
  isNotIconActiveStyles,
} from "../../utils/styles";

import { getAuth } from "firebase/auth";
import { motion } from "framer-motion";
import { app } from "../../config/firebase.config";
import { actionType } from "../../context/reducer";
import { buttonClick, HeaderTabMenu } from "../../utils/animations";

const Header = () => {
  const [{ user }, dispatch] = useStateValue();
  const [isTabMenu, setIsTabMenu] = useState(false);
  const firebaseAuth = getAuth(app);
  const navigate = useNavigate();

  const signout = () => {
    firebaseAuth
      .signOut()
      .then(() => {
        dispatch({
          type: actionType.SET_USER,
          user: null,
        });
        navigate("/login", { replace: true });
      })
      .catch((e) => console.log(e));
  };

  return (
    <div className=" w-full px-8 py-2 flex items-center justify-start shadow-sm gap-3">
      <img src={Logo} alt="" className=" w-40" />

      {/* <ul className="hidden md:flex items-center justify-center gap-8 ml-12">

        <NavLink to={"/"} className={({isActive}) => isActive ? isActiveStyles : isNotActiveStyles}>Home</NavLink>

        <NavLink to={"/forums"} className={({isActive}) => isActive ? isActiveStyles : isNotActiveStyles}>Forums</NavLink>

        <NavLink to={"/blogs"} className={({isActive}) => isActive ? isActiveStyles : isNotActiveStyles}>Blogs</NavLink>

        <NavLink to={"/about"} className={({isActive}) => isActive ? isActiveStyles : isNotActiveStyles}>About Us</NavLink>
      </ul> */}

      {/* <div className="fixed w-full p-4 inset-x-0 bottom-4 z-40 flex md:hidden items-center justify-center">
        <div className="bg-slate-50 gap-x-4 shadow-lg rounded-md w-340 p-2 py-4 flex items-center justify-evenly">

          <NavLink to={"/"} className={({isActive}) => isActive ? isIconActiveStyles : isNotIconActiveStyles}>
            <FaHome className="-rotate-0" />
          </NavLink>

          <NavLink to={"/forums"} className={({isActive}) => isActive ? isIconActiveStyles : isNotIconActiveStyles}>
            <MdForum className="-rotate-0" />
          </NavLink>

          <NavLink to={"/blogs"} className={({isActive}) => isActive ? isIconActiveStyles : isNotIconActiveStyles}>
            <FaBlog className="-rotate-0" />
          </NavLink>

          <NavLink to={"/about"} className={({isActive}) => isActive ? isIconActiveStyles : isNotIconActiveStyles}>
            <FcAbout className="-rotate-0" />
          </NavLink>
        </div>
      </div> */}

      {!user && (
        <motion.div {...buttonClick} className="ml-auto">
          <NavLink
            to={"/login"}
            className="px-4 py-1 rounded-md border border-gray-200 cursor-pointer hover:shadow-sm"
          >
            Login
          </NavLink>
        </motion.div>
      )}

      {user && (
        <motion.div
          className="cursor-pointer flex items-center justify-center gap-2 ml-auto relative"
          onMouseEnter={() => setIsTabMenu(true)}
          onMouseLeave={() => setIsTabMenu(false)}
        >
          <div className="relative">
            <img
              src={user?.picture ? user?.picture : user?.photoURL}
              referrerPolicy="no-referrer"
              className="w-12 h-12 rounded-full object-cover hover:shadow-md"
              alt=""
            />
            <div className="w-2 h-2 rounded-full bg-green-400 absolute bottom-0 right-2"></div>
          </div>
          <p className="text-xl font-semibold text-textColor hover:text-headingColor">
            {user?.name ? user?.name : user?.displayName}
            <span className="block -mt-1 text-sm font-normal">
              {user?.email && user?.email}
            </span>
          </p>

          {isTabMenu && (
            <motion.div
              {...HeaderTabMenu}
              className="py-4 w-225 shadow-lg rounded-md absolute top-12 left-0 bg-card cursor-pointer flex flex-col z-50 backdrop-blur-sm "
            >
              <NavLink
                to={`/userProfile/${user?.uid}`}
                className="text-lg text-textColor px-4 py-2 hover:bg-gray-100"
              >
                Profile
              </NavLink>

              {/* <NavLink
                to={`/favourites/${user?.uid}`}
                className="text-lg text-textColor px-4 py-2 hover:bg-gray-100"
              >
                Saved Videos
              </NavLink> */}
              {(user?.uid == process.env.REACT_APP_GMAIL_USER_ID ||
                user?.uid == process.env.REACT_APP_GITHUB_USER_ID) && (
                <NavLink
                  to={`/dashboard`}
                  className="text-lg text-textColor px-4 py-2 hover:bg-gray-100"
                >
                  Dashboard
                </NavLink>
              )}

              <NavLink
                to={``}
                className="text-lg text-textColor px-4 py-2 hover:bg-gray-100"
                onClick={signout}
              >
                Sign out
              </NavLink>
            </motion.div>
          )}
        </motion.div>
      )}
    </div>
  );
};

export default Header;
